export default "__VITE_PUBLIC_ASSET__7159c523__"